<template>
	<div class="page_warp">
		<div class="top_content">
			<div class="top_input">
				<el-input v-model="searchWord" placeholder="请输入"></el-input>
			</div>
			<div class="search_btn" @click="getData">查询</div>
			<div class="add_btn" @click="add" v-if="permissionItem.add">添加</div>
		</div>
		<div class="bottom_content">
			<div class="table_container" v-bind:id="tableId">
				<el-table v-bind:data="tableData" stripe border style="width: 100%" v-bind:max-height="tableHeight"
					v-bind:header-cell-style="{
            textAlign: 'center',
            color: '#333333',
            background: '#F5F5F5',
          }" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据">
					<!-- <el-table-column prop="roleId" label="角色ID"></el-table-column> -->
					<el-table-column prop="yyName" label="押运员名称"></el-table-column>
					<el-table-column prop="userLgname" label="帐号"></el-table-column>
					<el-table-column prop="yyPhone" label="手机号"></el-table-column>
					<el-table-column prop="yyCardid" label="身份证号"></el-table-column>
					<el-table-column label="性别">
						<template #default="scope">
							<span v-if="scope.row.yySex == '0'">男</span>
							<span v-else-if="scope.row.yySex == '1'">女</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column label="类型">
						<template #default="scope">
							<span v-if="scope.row.yyType == '0'">加盟</span>
							<span v-else-if="scope.row.yyType == '1'">外调</span>
							<span v-else-if="scope.row.yyType == '2'">临时</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column prop="yyHabitancy" label="居住地"></el-table-column>
					<el-table-column label="状态">
						<template #default="scope">
							<el-switch :value="scope.row.userStatusBoolen" active-text="正常" inactive-text="禁用"
								@change="updateState(scope.row)">
							</el-switch>
						</template>
					</el-table-column>
					<el-table-column prop="yyCretime" label="创建时间"></el-table-column>
					<el-table-column label="操作" width="280">
						<template #default="scope">
							<span v-if="permissionItem.edit" class="default_color pointer m-right10"
								v-on:click="edit(scope.row.yyUserId)">编辑</span>
							<span v-if="permissionItem.list" class="default_color pointer m-right10"
								v-on:click="detail(scope.row.yyUserId)">详情</span>
							<span v-if="permissionItem.reset" class="default_color pointer m-right10"
								v-on:click="resetMm(scope.row)">重置密码</span>
							<span v-if="permissionItem.setpwd" class="default_color pointer m-right10"
								v-on:click="savePasswordSetting(scope.row)">修改密码</span>
							<span v-if="permissionItem.del" class="col-FF1A1A pointer"
								v-on:click="del(scope.row.yyUserId)">删除</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="flex flex-y-center flex-x-center">
				<el-config-provider :locale="locale">
					<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
						:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper"
						:total="totalCount" @size-change="getData" @current-change="getData" />
				</el-config-provider>
			</div>
		</div>

		<el-dialog :title="'【'+saveItem.userName+'】旧密码修改'" v-model="showSavePasswordModle" width="40%" center>
			<div class="dialog-container">
				<div class="dialog-row">
					<span>&emsp;&emsp;旧密码：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="saveItem.oldPassword" type="password">
						</el-input>
					</div>
				</div>

				<div class="dialog-row">
					<span>&emsp;&emsp;新密码：</span>

					<div class="input-box">
						<el-input placeholder="密码最少8位，必须包含大小写和数字" v-model="saveItem.password" type="password">
						</el-input>
					</div>
				</div>

				<div class="dialog-row">
					<span>确认新密码：</span>
					<div class="input-box">
						<el-input placeholder="密码最少8位，必须包含大小写和数字" v-model="saveItem.password1" type="password">
						</el-input>
					</div>
				</div>
			</div>
			<template #footer>
				<span class="dialog-footer">
					<span class="btn btn-outline-default mr-50" @click="closeSave()">取消</span>
					<span class="btn bg-default" @click="submitSavePassword()">确定</span>
				</span>
			</template>
		</el-dialog>

		<Add ref="addRef" v-if="isAdd" @getData="getData" />
		<Edit ref="editRef" v-if="isEdit" @getData="getData" />
		<Detail ref="detailRef" v-if="isDetail" @getData="getData" />
		<!-- <div class="menuManagemen" v-if="isAdd">
      <Add :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isEdit">
      <Edit :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isDetail">
      <Detail
        :sendData="sendData"
        @closeModal="closeModal"
        @getData="getData"
      />
    </div> -->
	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRefs,
		nextTick,
		onMounted,
		getCurrentInstance,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import Add from "./components/add";
	import Edit from "./components/edit";
	import Detail from "./components/detail";
	import zhCn from "element-plus/es/locale/lang/zh-cn";
	export default defineComponent({
		components: {
			Add,
			Edit,
			Detail
		},
		name: "escortManage",
		setup() {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const data = reactive({
				tableId: "roleManagementTable",
				page: 1,
				pageSize: 10,
				searchWord: "",
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				isAdd: false,
				isEdit: false,
				isDetail: false,
				sendData: null,
				locale: zhCn,
				showSavePasswordModle: false,
				saveItem: {
					userId: "",
					userName: "",
					oldPassword: "",
					password: "",
					password1: "",
				},

				permissionItem: {
					list: false,
					add: false,
					edit: false,
					del: false,
					reset: false,
					setpwd: false,
				},
			});
			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "escortManage:list") {
						data.permissionItem.list = true;
					}
					if (el == "escortManage:add") {
						data.permissionItem.add = true;
					}
					if (el == "escortManage:edit") {
						data.permissionItem.edit = true;
					}
					if (el == "escortManage:del") {
						data.permissionItem.del = true;
					}
					if (el == "escortManage:reset") {
						data.permissionItem.reset = true;
					}
					if (el == "escortManage:setpwd") {
						data.permissionItem.setpwd = true;
					}
				});
				
				console.log(store.state.userInfo);
				nextTick(() => {
					data.tableHeight =
						document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight - 40;
					getData();
				});
				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
					});
				};
			});
			//获取列表数据
			const getData = async () => {
				if (!data.permissionItem.list) {
					proxy.$message.error("没有查询押运员列表权限！");
					return;
				}
				
				let params = {
					searchWord: data.searchWord,
					page: data.page,
					limit: data.pageSize,
					// roleOrg: store.state.userInfo.orgId,
				};
				const r = await proxy.$http.get(apiObj.yyList, params);
				console.log(r);
				if (r.code === 0) {
					r.rows.forEach((el) => {
						el.userStatusBoolen = el.userStatus == 0 ? true : false;
					});
					data.tableData = r.rows;
					data.totalCount = r.total;
				}
			};

			// 添加 根目录
			const add = () => {
				if (!data.permissionItem.add) {
					proxy.$message.error("没有押运员添加权限！");
					return;
				}
				
				data.isAdd = true;
				nextTick(() => {
					proxy.$refs.addRef.init();
				});
			};

			// 菜单编辑
			const edit = (id) => {
				if (!data.permissionItem.edit) {
					proxy.$message.error("没有押运员编辑权限！");
					return;
				}
				
				data.isEdit = true;
				nextTick(() => {
					proxy.$refs.editRef.init(id);
				});
			};
			// 菜单详情
			const detail = (id) => {
				if (!data.permissionItem.list) {
					proxy.$message.error("没有押运员查询权限！");
					return;
				}
				
				data.isDetail = true;
				nextTick(() => {
					proxy.$refs.detailRef.init(id);
				});
			};
			//菜单删除
			const del = (yyUserId) => {
				if (!data.permissionItem.del) {
					proxy.$message.error("没有押运员删除权限！");
					return;
				}
				
				proxy
					.$confirm("您确定删除选中的数据吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							yyUserId: yyUserId,
						};
						const r = await proxy.$http.postFormData(apiObj.yyDel, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			// 重置密码
			const resetMm = (row) => {
				if (!data.permissionItem.reset) {
					proxy.$message.error("没有押运员重置密码权限！");
					return;
				}
				
				var val = row.yyUserId;
				proxy.$confirm(
					"您确定将" +
					"(" +
					row.yyName +
					")重置密码为‘123456’吗?",
					"提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}
				).then(() => {
					proxy.$http
						.postFormData(apiObj.userResetPassword, {
							userId: val
						}, {
							headers: {
								"Content-Type": "application/x-www-form-urlencoded"
							},
						})
						.then((res) => {
							if (res.code == 0 || res.respCode == "0000") {
								proxy.$message.success(res.msg || res.respMsg);
							} else {
								proxy.$message.info(res.msg || res.respMsg);
							}
						});
				});
			};

			const updateState = (row) => {
				if (!data.permissionItem.edit) {
					proxy.$message.error("没有押运员编辑权限！");
					return;
				}
				
				proxy.$confirm(
					`您确定执行${!row.userStatusBoolen ? "启用" : "禁用"}操作，是否继续?`,
					"提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}
				).then(async () => {
					proxy.$http
						.postFormData(
							"/biz/bdzl/yayunInfo/updateStatus", {
								yyUserId: row.yyUserId,
								status: row.userStatusBoolen ? 1 : 0
							}, {
								headers: {
									"Content-Type": "application/x-www-form-urlencoded"
								},
							}
						)
						.then((res) => {
							if (res.code == 0 || res.respCode == "0000") {
								proxy.$message.success(res.msg || res.respMsg);
								getData();
							} else {
								proxy.$message.info(res.msg || res.respMsg);
							}
						});
				});
			};

			//安全设置 弹框
			const savePasswordSetting = (row) => {
				if (!data.permissionItem.setpwd) {
					proxy.$message.error("没有押运员修改密码权限！");
					return;
				}
				
				data.saveItem.userId = row.yyUserId;
				data.saveItem.userName = row.yyName;
				data.showSavePasswordModle = true;
			};

			//安全设置 关闭
			const closeSave = () => {
				data.showSavePasswordModle = false;
			};

			//提交安全设置
			const submitSavePassword = () => {
				if (data.saveItem.oldPassword == "") {
					proxy.$message.error("请输入原始密码");
					return;
				}
				if (data.saveItem.password == "") {
					proxy.$message.error("请输入新密码");
					return;
				}
				if (data.saveItem.password1 == "") {
					proxy.$message.error("请确认新密码");
					return;
				}
				if (data.saveItem.password != data.saveItem.password1) {
					proxy.$message.error("密码不一致");
					return;
				}
				if (data.saveItem.password.length < 8) {
					proxy.$message.error("密码最少设置8位");
					return;
				}
				// if (!/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)/.test(data.saveItem.password)) {
				//   proxy.$message.error("密码必须包含大小写字母和数字");
				//   return;
				// }
				let params = {
					userId: data.saveItem.userId,
					oldPassword: data.saveItem.oldPassword,
					password: data.saveItem.password,
				};
				proxy.$http
					.postFormData(apiObj.userChangePassword, params, {
						headers: {
							"Content-Type": "application/x-www-form-urlencoded"
						},
					})
					.then((res) => {
						if (res.code == 0 || res.respCode == "0000") {
							proxy.$message.success(res.respMsg);
							data.showSavePasswordModle = false;
						} else {
							proxy.$message.error(res.respMsg);
							data.saveItem.oldPassword = "";
							data.saveItem.password = "";
							data.saveItem.password1 = "";
						}
					});
			};

			return {
				...toRefs(data),
				getData,
				add,
				edit,
				detail,
				del,
				updateState,
				resetMm,
				savePasswordSetting,
				closeSave,
				submitSavePassword
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 100%;
	}

	.dialog-container .dialog-row {
		width: 100%;
		height: 50px;
		margin-bottom: 10px;

		display: flex;
		align-items: center;
		justify-content: center;
	}

	.dialog-container .dialog-row .dialog-row-left {
		min-width: 130px;
		text-align: right;
	}

	.dialog-container .dialog-row .input-box {
		width: 50%;
		height: 100%;

		display: flex;
		align-items: center;
		justify-content: center;
	}

	.dialog-container .dialog-row .input-box input[type="text"],
	.dialog-container .dialog-row .input-box input[type="number"],
	.dialog-container .dialog-row .input-box select {
		width: 100%;
		height: 33px;
		border: 1px solid #f5f5f5;
	}

	.dialog-container .dialog-row .input-box input[type="text"],
	.dialog-container .dialog-row .input-box input[type="number"] {
		padding-left: 5px;
	}

	.dialog-container .dialog-row .input-box select {
		cursor: pointer;
	}

	.dialog-container .dialog-row .input-box input[type="text"]:focus,
	.dialog-container .dialog-row .input-box select:focus {
		outline: none;
	}

	.dialog-container .blank-img {
		display: inline-block;
		width: 72px;
		height: 72px;
		background: #f5f5f5;
	}

	.dialog-container .btn {
		padding: 5px 15px;

		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;

		display: flex;
		align-items: center;
		justify-content: center;
	}

	.dialog-footer .btn {
		padding: 8px 30px;
		color: #333;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}
</style>